// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './ScrapInputBlock.scss';
import inputStyle from '../../../../assets/styles/input.scss';
import buttonStyle from '../../../../assets/styles/button.scss';
import { FormattedMessage } from 'react-intl';

type Props = {
  +handleClickButton: (url: string) => void;
};

type State = {
  +url: {
    value: string;
    errors?: string[];
  };
};

export default class ScrapInputBlock extends Component<Props, State> {
  state = {
    url: {
      value: '',
    }
  };

  handleChange = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      const { name, value } = e.target;
      this.setState({ [name]: { value } });
    }
  };

  handleSubmit = (e: Event) => {
    e.preventDefault();
    const { handleClickButton } = this.props;
    const { url } = this.state;
    handleClickButton(url.value);
  };

  render() {
    const { url } = this.state;
    return (
      <form className={style.scrapFormContent}
            onSubmit={this.handleSubmit}>
        <FormattedMessage id='store.scrapInputBlock.found.product'>{
          txt => <h1>{txt}</h1>
        }</FormattedMessage>
        <FormattedMessage id='store.scrapInputBlock.quote.now'>{
          txt => <p>{txt}</p>
        }</FormattedMessage>
        <section className={style.inputWrap}>
          <FormattedMessage id='store.scrapInputBlock.generic.input.url.placeholder'>{
            txt => <input type="text"
                          name='url'
                          value={url.value}
                          className={classNames(inputStyle.input,
                            { [inputStyle.red]: url.errors && url.errors.length })}
                          onChange={this.handleChange}
                          placeholder={txt}/>
          }</FormattedMessage>
          <FormattedMessage id='store.scrapInputBlock.button.quote'>{
            txt =>
              <button type='submit'
                      className={classNames(buttonStyle.btn, buttonStyle.orange)}>
                {txt}
              </button>
          }</FormattedMessage>
        </section>
      </form>
    )
  }
}

ScrapInputBlock.propTypes = {
  handleClickButton: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/store/GenericStore/ScrapInputBlock/ScrapInputBlock.jsx